
import wx from 'weixin-js-sdk'

import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'curtainAddWorker',
components: {
wx,XTextarea,Group
},
data() {
return {
formData:{
id:0,
name:'',
phone:'',
account:'',
},
}
},
created() {
this.formData.id = Number(this.$route.params.id);
if(this.formData.id > 0){
this.getWorker();
}
},
methods: {
getWorker() {
this.$api.getWorkerList({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data;
}
})
},
submit() {
if(!this.formData.name){
this.$func.showToast('请输入姓名');
return false;
}
if(!this.formData.phone){
this.$func.showToast('请输入电话');
return false;
}
if(!this.formData.account){
this.$func.showToast('请输入登录账号');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.curtainAddWorker(this.formData).then((res)=>{
if(res){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
}
});
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/curtainAddWorker.vue